var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accessGranted)?_c('div',[_c('DemoForm',{ref:"form",attrs:{"loading":_vm.loading,"errorsData":_vm.errorsData,"transporters":_vm.transporterList},on:{"validate-demo":_vm.createDemo,"cancel":_vm.cancel},model:{value:(_vm.demo),callback:function ($$v) {_vm.demo=$$v},expression:"demo"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }